import React from 'react';
import { PaymentMethod } from '~/types/Payment';
import PaymentTab from '../PaymentTab';

const WalletTab = ({
  onSubmit,
}: {
  onSubmit: (params: { method: PaymentMethod; description: string }) => void;
}) => {
  const handleSubmit = (desc: string) => {
    onSubmit({
      method: PaymentMethod.Wallet,
      description: desc,
    });
  };
  return <PaymentTab placeholder="Pilih e-Wallet" onSubmit={handleSubmit} />;
};

export default WalletTab;
